//styles
import { useState } from "react"
import styles from "../../../../styles/referrals/MapSearchCategorySelection.module.css"

//PrimeReact
import { ListBox } from "primereact/listbox"
import { InputText } from "primereact/inputtext"

export default function CategorySelection({
  selectedLocation,
  onCancelSelection,
  onSubmitSelection,
}) {
  const [selectedCategory, setSelectedCategory] = useState(undefined)
  const [otherValue, setOtherValue] = useState("")
  const isOther = selectedCategory?.toLowerCase().includes("other")

  const submitSelection = (category, other) => {
    onSubmitSelection({
      ...selectedLocation,
      referralCategory: category,
      referralCategoryOther: other,
    })
  }

  if (selectedLocation.referralCategories.length === 0) {
    submitSelection("Unknown", "")
  } else if (selectedLocation.referralCategories.length === 1 && !isOther) {
    submitSelection(selectedLocation.referralCategories[0], "")
  } else if (selectedLocation.referralCategories.length === 1 && isOther) {
    setSelectedCategory(selectedLocation.referralCategories[0])
  }

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.grid} ${isOther ? styles.gridOther : ""}`}>
        <div className={styles.gridAreaServices}>
          <ListBox
            className={styles.list}
            options={selectedLocation.referralCategories}
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.value)}
            filter
          />
        </div>
        {isOther ? (
          <div className={styles.gridAreaOther}>
            <div>
              Other description <span style={{ color: "red" }}> * </span>
            </div>
            <InputText
              value={otherValue}
              onChange={(e) => {
                setOtherValue(e.target.value)
              }}
              required={true}
            />
          </div>
        ) : null}

        <div className={styles.gridAreaButton}>
          <button
            type="button"
            className={`btn ${styles.button}`}
            disabled={!selectedCategory || (isOther && !otherValue)}
            onClick={() => {
              if (!!selectedCategory) {
                submitSelection(selectedCategory, otherValue)
              }
            }}
          >
            Submit
          </button>
          <button
            type="button"
            className={`btn ${styles.button}`}
            onClick={() => {
              onCancelSelection()
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
